import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import AppShell from "../../../components/layout/AppShell";
import Input from "../../../components/ui/Input";
import Button from "../../../components/ui/Button";
import { createUser } from "../../../services/api";

const COUNTRY_OPTIONS = [
  // North America
  { value: "US", label: "United States (US)" },
  // Middle East
  { value: "AE", label: "United Arab Emirates (AE)" },
  // Africa
  { value: "ET", label: "Ethiopia (ET)" },
  { value: "GH", label: "Ghana (GH)" },
  { value: "KE", label: "Kenya (KE)" },
  { value: "MW", label: "Malawi (MW)" },
  { value: "MZ", label: "Mozambique (MZ)" },
  { value: "NG", label: "Nigeria (NG)" },
  { value: "RW", label: "Rwanda (RW)" },
  { value: "ZA", label: "South Africa (ZA)" },
  { value: "TZ", label: "Tanzania (TZ)" },
  { value: "UG", label: "Uganda (UG)" },
  { value: "ZM", label: "Zambia (ZM)" },
  { value: "ZW", label: "Zimbabwe (ZW)" },
];

const CreateSender = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name:        "",
    email:       "",
    contactName: "",
    phone:       "",
    country:     "",
  });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const set = (field, val) => {
    setForm((p) => ({ ...p, [field]: val }));
    setErrors((p) => ({ ...p, [field]: "" }));
  };

  const validate = () => {
    const errs = {};
    if (!form.name.trim())        errs.name        = "Company name is required.";
    if (!form.email.trim())       errs.email       = "Contact email is required.";
    else if (!/\S+@\S+\.\S+/.test(form.email)) errs.email = "Enter a valid email address.";
    if (!form.contactName.trim()) errs.contactName = "Contact name is required.";
    if (!form.country)            errs.country     = "Please select a country.";
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setSubmitting(true);
    try {
      await createUser({ ...form, type: "sender" });
      toast.success("Invitation sent successfully");
      navigate("/receiver/senders");
    } catch {
      toast.error("Failed to send invitation. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AppShell>
      <div className="max-w-[560px]">
        <h1 className="text-2xl font-bold text-gray-900 mb-1">Add a New Sender</h1>
        <p className="text-sm text-gray-500 mb-6">
          Invite a business to send payments to you. They'll be auto-mapped to your account.
        </p>

        <div className="bg-white border border-gray-200 rounded-xl p-6">
          <form onSubmit={handleSubmit} noValidate>
            <div className="space-y-5">
              <Input
                label="Business / Company Name"
                name="name"
                value={form.name}
                onChange={(e) => set("name", e.target.value)}
                placeholder="e.g. Acme Corp Ltd"
                error={errors.name}
                required
              />
              <Input
                label="Contact Email"
                type="email"
                name="email"
                value={form.email}
                onChange={(e) => set("email", e.target.value)}
                placeholder="payments@example.com"
                error={errors.email}
                required
              />
              <Input
                label="Contact Name"
                name="contactName"
                value={form.contactName}
                onChange={(e) => set("contactName", e.target.value)}
                placeholder="Primary contact person's full name"
                error={errors.contactName}
                required
              />
              <Input
                label="Phone Number (optional)"
                type="tel"
                name="phone"
                value={form.phone}
                onChange={(e) => set("phone", e.target.value)}
                placeholder="+971 50 000 0000"
              />

              {/* Country dropdown */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">
                  Country <span className="text-red-400">*</span>
                </label>
                <select
                  value={form.country}
                  onChange={(e) => set("country", e.target.value)}
                  className={`w-full border rounded-xl px-4 py-3 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-brand/30 focus:border-brand ${
                    errors.country
                      ? "border-red-400 text-gray-400"
                      : form.country
                      ? "border-gray-200 text-gray-900"
                      : "border-gray-200 text-gray-400"
                  }`}
                >
                  <option value="">Select country...</option>
                  {COUNTRY_OPTIONS.map((c) => (
                    <option key={c.value} value={c.value}>{c.label}</option>
                  ))}
                </select>
                {errors.country && (
                  <p className="mt-1 text-xs text-red-500">{errors.country}</p>
                )}
              </div>
            </div>

            <div className="mt-8 flex justify-center">
              <Button type="submit" loading={submitting} fullWidth={false} className="px-12">
                Send Invitation
              </Button>
            </div>
          </form>
        </div>
      </div>
    </AppShell>
  );
};

export default CreateSender;
